import * as tslib_1 from "tslib";
import { CreateImportInput, Import, ImportListParams, ImportOrderByInputEnum, PagedResult, StartImportAndValidationInput, UpdateImportFileInput, UploadCredential, UploadCredentialInput } from '@core/interfaces';
import { Apollo } from 'apollo-angular';
import { ImportsQueriesService } from './queries/imports.queries.service';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./queries/imports.queries.service";
var ImportsService = /** @class */ (function () {
    function ImportsService(apollo, queries) {
        this.apollo = apollo;
        this.queries = queries;
    }
    ImportsService.prototype.listImports = function (_a) {
        var where = _a.where, options = _a.options;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, variables;
            return tslib_1.__generator(this, function (_b) {
                query = this.queries.listImports();
                variables = {
                    orderBy: ImportOrderByInputEnum[options.orderBy],
                    where: where,
                    limit: options.limit,
                    offset: options.offset
                };
                return [2 /*return*/, this.apollo
                        .query({ query: query, variables: variables })
                        .toPromise()
                        .then(function (response) { return response.data['imports']; })];
            });
        });
    };
    ImportsService.prototype.getImportById = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, variables;
            return tslib_1.__generator(this, function (_a) {
                query = this.queries.getImportById();
                variables = { id: id };
                return [2 /*return*/, this.apollo
                        .query({ query: query, variables: variables })
                        .toPromise()
                        .then(function (response) { return response.data['import']; })];
            });
        });
    };
    ImportsService.prototype.watchImportById = function (id) {
        var query = this.queries.getImportById();
        var variables = { id: id };
        return this.apollo
            .watchQuery({ query: query, variables: variables, pollInterval: 2000 });
    };
    ImportsService.prototype.createUploadCredential = function (_a) {
        var size = _a.size, extension = _a.extension, entity = _a.entity;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mutation, variables;
            return tslib_1.__generator(this, function (_b) {
                mutation = this.queries.generateUploadCredential();
                variables = {
                    input: {
                        size: size,
                        extension: extension,
                        entity: entity
                    }
                };
                return [2 /*return*/, this.apollo
                        .mutate({ mutation: mutation, variables: variables })
                        .toPromise()
                        .then(function (response) { return response.data['generateUploadCredential']; })];
            });
        });
    };
    ImportsService.prototype.createImport = function (_a) {
        var type = _a.type, fileKey = _a.fileKey, bucketName = _a.bucketName;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mutation, variables;
            return tslib_1.__generator(this, function (_b) {
                mutation = this.queries.createImport();
                variables = {
                    input: {
                        type: type,
                        fileKey: fileKey,
                        bucketName: bucketName
                    }
                };
                return [2 /*return*/, this.apollo
                        .mutate({ mutation: mutation, variables: variables })
                        .toPromise()
                        .then(function (response) { return response.data['createImport']; })];
            });
        });
    };
    ImportsService.prototype.updateImportFile = function (_a) {
        var id = _a.id, updatedAt = _a.updatedAt, fileKey = _a.fileKey, bucketName = _a.bucketName;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mutation, variables;
            return tslib_1.__generator(this, function (_b) {
                mutation = this.queries.updateImportFile();
                variables = {
                    input: {
                        id: id,
                        fileKey: fileKey,
                        updatedAt: updatedAt,
                        bucketName: bucketName
                    }
                };
                return [2 /*return*/, this.apollo
                        .mutate({ mutation: mutation, variables: variables })
                        .toPromise()
                        .then(function (response) { return response.data['updateImportFile']; })];
            });
        });
    };
    ImportsService.prototype.startImportValidation = function (_a) {
        var id = _a.id, updatedAt = _a.updatedAt, language = _a.language;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mutation, variables;
            return tslib_1.__generator(this, function (_b) {
                mutation = this.queries.startImportValidation();
                variables = {
                    input: {
                        id: id,
                        updatedAt: updatedAt,
                        language: language
                    }
                };
                return [2 /*return*/, this.apollo
                        .mutate({ mutation: mutation, variables: variables })
                        .toPromise()
                        .then(function (response) { return response.data['startImportValidation']; })];
            });
        });
    };
    ImportsService.prototype.startImport = function (_a) {
        var id = _a.id, updatedAt = _a.updatedAt, language = _a.language;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mutation, variables;
            return tslib_1.__generator(this, function (_b) {
                mutation = this.queries.startImport();
                variables = {
                    input: {
                        id: id,
                        updatedAt: updatedAt,
                        language: language
                    }
                };
                return [2 /*return*/, this.apollo
                        .mutate({ mutation: mutation, variables: variables })
                        .toPromise()
                        .then(function (response) { return response.data['startImport']; })];
            });
        });
    };
    ImportsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ImportsService_Factory() { return new ImportsService(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.ImportsQueriesService)); }, token: ImportsService, providedIn: "root" });
    return ImportsService;
}());
export { ImportsService };
